import { Injectable } from '@angular/core';
import * as dayjs from 'dayjs';
import { Subject, Observable } from 'rxjs';
import { LocalStorageKeys } from '../shared/enums/local-storage-keys';

@Injectable({
  providedIn: 'root'
})
export class PwaService {
  private readonly popup = new Subject<boolean>();

  set show(value: boolean) {
    this.popup.next(value);
  }

  get showPopup(): Observable<boolean> {
    return this.popup.asObservable();
  }

  canAsk(): boolean {
    if (!this.isStorageAvailable()) {
      return false;
    }

    const strPopupDate = localStorage.getItem(LocalStorageKeys.PWA_POPUP_DATE);

    if (!strPopupDate) {
      return true;
    }

    if (strPopupDate.length > 0) {
      const popupDate = dayjs(new Date(strPopupDate));
      if (dayjs(new Date()).isAfter(popupDate)) {
        localStorage.removeItem(LocalStorageKeys.PWA_POPUP_DATE);
        return true;
      }
    }

    return false;
  }

  setPopupDate(): void {
    if (!this.isStorageAvailable()) {
      return;
    }

    const popupDate = new Date();
    popupDate.setDate(popupDate.getDate() + 1);
    localStorage.setItem(LocalStorageKeys.PWA_POPUP_DATE, popupDate.toLocaleString());
  }

  private isStorageAvailable(): boolean {
    return typeof localStorage !== 'undefined';
  }

}
